import React, { useState, useEffect } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Layout } from "antd";
import { connect } from "react-redux";
import Header from "../components/Header";

import "./index.scss";

const { Content, Sider } = Layout;
const LayoutComponent = withRouter(({ children }) => {
  const [weaDay, seWeaDay] = useState("");
  const [tem, seTem] = useState("");
  useEffect(() => {
    getAPi();
    setInterval(() => {
      getAPi();
    }, 86400000);

    return () => {};
  }, []);

  const getAPi = () => {
    axios
      .get("http://www.nmc.cn/rest/weather?stationid=56985&_=1632735845455")
      .then(({ data }) => {
        if (data.code == 0) {
          let { info, temperature } = data.data.real.weather;
          info && localStorage.setItem("wea_day", info);
          temperature && localStorage.setItem("tem", temperature);
          seTem(temperature);
          seWeaDay(info);
        }
      })
      .catch((err) => {
        localStorage.getItem("wea_day") &&
          seWeaDay(localStorage.getItem("wea_day"));
        localStorage.getItem("tem") && seTem(localStorage.getItem("tem"));
      });
  };

  return (
    <Layout className="layout-wrap2">
      <Header weaDay={weaDay} tem={tem} />
      <Layout>
        <Layout>
          <Content
            className="site-layout-background"
            style={{
              padding: 0,
              margin: 0,
              display: "flex",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
});
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(LayoutComponent);
